import React, { forwardRef } from "react";
import styled from "@emotion/styled";
import { fromPublic } from "../../utils";

interface OnboardingContentProps {
  children: React.ReactNode;
  iconUrl?: string;
}

const StyledTextContainer = styled.div<{ iconUrl?: string }>`
  text-align: left;
  padding-bottom: 1rem; /* Use rem for spacing */
  margin-top: 1rem;
  background-color: #eff2f5;

  p {
    color: #2f383c;
    font-size: 1rem; /* Use relative units */
    font-style: normal;
    font-weight: 400 !important;
    line-height: 1.5; /* Use relative line height */
    letter-spacing: -0.02em;
  }
  ul {
    padding-left: 1.5em;
    list-style-type: disc;
    li {
      font-size: 1rem !important;
      line-height: 1.5;
      margin-bottom: 0.5em;
    }
  }
  ol {
    padding-left: 1.5em;
    list-style-type: decimal;
    li {
      font-size: 1rem !important;
      line-height: 1.5;
      margin-bottom: 0.5em;
    }
  }
  .icon-list {
    list-style-type: none;
    padding-left: 0;
  }
  .icon-list li {
    position: relative;
    padding-left: 1.5em;
    ${(props) =>
      props.iconUrl
        ? `background: url("${props.iconUrl}") no-repeat left 0.2em;`
        : ""}
    background-size: 1em; /* Scale with font size */
    min-height: 1em;
    margin-bottom: 0.5em;
    list-style-type: none;
  }
`;

const OnboardingContent = forwardRef<HTMLDivElement, OnboardingContentProps>(
  ({ children, iconUrl }, ref) => {
    const finalIconUrl = iconUrl ? fromPublic(iconUrl) : undefined;
    return (
      <StyledTextContainer ref={ref} iconUrl={finalIconUrl}>
        {children}
      </StyledTextContainer>
    );
  }
);

export default OnboardingContent;